// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3700":"4710dc24","4044":"61360f62","5425":"61360f62"}[chunkId] + ".chunk.css";
};